import { useGLTF } from '@react-three/drei'
import { useKTX2 } from '../../../utils/useKtx'
import { useEffect, useMemo } from 'react'
import * as THREE from 'three'

export default function Floor() {
  const { nodes } = useGLTF('/models/01/floor.glb')
  const base = useKTX2('./textures/01/sol-base.ktx2')
  const texA = useMemo(() => base.clone(), [base])

  useEffect(() => {
    texA.wrapS = texA.wrapT = THREE.RepeatWrapping
    texA.repeat.set(1, 10)
    texA.needsUpdate = true
  }, [texA])

  return (
    <mesh geometry={nodes.Floor.geometry}
      position={[0, 0, 0]}
      receiveShadow
    >
      <meshStandardMaterial
        map={texA}
        roughness={0.2}
      />
    </mesh>
  )
}

useGLTF.preload("/models/01/floor.glb")

